//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import scroll from '@/mixins/scroll'
import AButton from './components/button/button.vue'

export default {
  components: { AButton },
  mixins: [scroll],
  props: {
    buttonText: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
}
